import { render, staticRenderFns } from "./pcHome.vue?vue&type=template&id=162304bb&scoped=true&"
import script from "./pcHome.vue?vue&type=script&lang=js&"
export * from "./pcHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162304bb",
  null
  
)

export default component.exports